/**
 * @Description 人口客群
 */

import { FC } from 'react';
import styles from './index.module.less';
import Header from '../Header';
import GenderRate from '../GenderRate';
import PPTBarChart from '../BarChart';
import PPTPieChart from '../PieChart';

const PeopleFlow:FC<any> = ({
  rangeName,
  peopleStatisticsVO,
}) => {
  return (
    <div className={styles['page']}>
      <Header title={`客流画像 — ${rangeName}`}/>

      <div className={styles['content']}>
        <div className={styles['discription']}>{peopleStatisticsVO?.passengerFlowPortraitIntroduction || '-'}</div>

        <div className={styles['main']}>
          <div className={styles['left']}>
            <GenderRate
              title='人口客群'
              showLable
              value={peopleStatisticsVO?.maleRate}
              femaleValue={peopleStatisticsVO?.femaleRate}/>

            <div className={styles['age-chart']}>
              <PPTBarChart
                width={663}
                height={327}
                title='年龄分布'
                xAxisData={peopleStatisticsVO?.ageRates?.map((item) => item.name) || []}
                direction='horizontal'
                seriesData={[{
                  data: peopleStatisticsVO?.ageRates?.map((item) => item.rate) || [],
                  itemStyle: {
                    color: '#8B3DFF',
                    borderRadius: [0, 100, 100, 0]
                  },
                  barWidth: 20,
                  label: {
                    formatter: (params: any) => {
                      return params.value + '%';
                    }
                  }
                }]}
                config={{
                  yAxis: {
                    show: false
                  },
                  xAxis: {
                    axisLabel: {
                      color: '#999999',
                      lineHeight: 22,
                      fontSize: 16,
                      fontWeight: 400,
                      width: 65,
                      align: 'right',
                      overflow: 'truncate',
                    },
                  },
                  title: {
                    top: 0,
                    left: 0,
                    textStyle: {
                      color: '#222222',
                      fontWeight: 500,
                      fontSize: 24,
                      lineHeight: 33,
                    },
                  },
                  grid: {
                    top: 54,
                    left: 80,
                    bottom: 9,
                    right: 126
                  },
                  legend: {
                    show: false
                  }
                }}
              />
            </div>
          </div>

          <div className={styles['right']}>
            <div className={styles['pie-chart']}>
              <PPTPieChart
                title='消费水平'
                type='circle'
                height={252}
                seriesData={[{
                  data: peopleStatisticsVO?.consumptionLevel?.map((item) => { return { ...item, value: item.rate }; }) || [],
                }]}
                config={{
                  legend: {
                    height: '100%',
                    itemGap: 20,
                    left: '300px'
                  },
                }}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeopleFlow;
